<template>
  <div class="datum">
    <!-- 媒体信息 -->
    <el-row class="ml138">
      <div class="face">
        <img :src="user_info.face||default_avatar" alt />
      </div>
      <div class="header mt32">
        <div class="title">
          <span>{{user_info.taobao_nickname || user_info.telephone}}</span>
          <span :class="role">
            <i>{{role_cn}}</i>
          </span>
        </div>
        <!-- <zt-button
          class="mr8"
          size="medium"
          @click="dialogVisible.media = true"
          :loading="loading.dialogMedia"
        >修改媒体信息</zt-button>-->
      </div>
      <div class="desc mt1 mb8">{{media.desc || '这个人忙着挣钱,还没有时间写简介'}}</div>
      <el-row>
        <el-col>
          <div class="info-table">
            <div class="info-table-row">
              <div class="label">擅长领域:</div>
              <div class="content">
                <template v-if="media.specialty.length">
                  <span
                    v-for="(item,index) in media.specialty"
                    class="kind-tag"
                    :key="index"
                  >{{item}}</span>
                </template>
                <template v-else>
                  <span class="kind-tag">暂无</span>
                </template>
              </div>
            </div>
            <!-- <div class="info-table-row">
              <div class="label">大淘号QQ:</div>
              <div class="content">{{media.qq}}</div>
            </div>-->
          </div>
        </el-col>
      </el-row>
    </el-row>

    <!-- <div class="ml138 mt24 mb8 border1"></div> -->
    <!-- 联系信息 -->
    <!-- <el-row class="ml138">
      <div class="header mb8">
        <div class="title">联系信息</div>
        <zt-button
          class="mr8"
          size="medium"
          @click="dialogVisible.contact = true"
          :loading="loading.dialogMedia"
        >修改联系信息</zt-button>
      </div>
      <el-row>
        <el-col :span="12">
          <div class="info-table">
            <div class="info-table-row">
              <div class="label">运营者姓名:</div>
              <div class="content">{{contact.name}}</div>
            </div>
            <div class="info-table-row">
              <div class="label">身份证号码:</div>
              <div class="content">{{contact.identity}}</div>
            </div>
            <div class="info-table-row">
              <div class="label">手机号码:</div>
              <div class="content">{{contact.phone}}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-table">
            <div class="info-table-row">
              <div class="label">联系QQ:</div>
              <div class="content">{{contact.qq}}</div>
            </div>
            <div class="info-table-row">
              <div class="label">邮箱:</div>
              <div class="content">{{contact.email}}</div>
            </div>
            <div class="info-table-row">
              <div class="label">所在地:</div>
              <div class="content">{{contact.location}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-row>-->
    <!-- <div class="ml138 mt24 border1"></div> -->
    <!-- <el-row class="ml138 mt12 mb36" type="flex" justify="end">
      <zt-button type="primary" size="medium">申请企业认证</zt-button>
    </el-row>-->
    <!-- dialog-媒体信息 -->
    <zt-dialog
      title="修改媒体信息"
      :append-to-body="true"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible.media"
    >
      <el-form
        class="dialog-form mt8"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
        @submit.native.prevent
        :model="formMedia"
        ref="formMedia"
      >
        <el-form-item label="昵称：">
          <el-input class="input-middle" v-model.trim="formMedia.nick" placeholder="请输入昵称"></el-input>
          <zt-button type="primary" class="input-button" plain size="medium">名称检测</zt-button>
          <p class="help">*修改名称不得使用网红名人、购物网购平台、含明显广告意图等</p>
        </el-form-item>
        <el-form-item label="头像：">
          <el-input
            v-model.trim="formMedia.nick"
            class="textarea"
            type="textarea"
            rows="3"
            placeholder="请输入昵称"
          />
          <p class="help">*请填写淘宝图片空间地址，切勿使用恶意、违法及含明显广告意图的图片</p>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model.trim="formMedia.remark"
            class="textarea"
            type="textarea"
            rows="3"
            placeholder="请输入备注"
          />
          <p class="help">*字数在70字以内，要求完成通顺，无特殊符号，对所选属性或特长领域做相关介绍。</p>
        </el-form-item>
        <el-form-item label="QQ：">
          <el-input type="number" step="1" v-model.trim="formMedia.qq" placeholder="请输入QQ"></el-input>
          <p class="help">外部通过该QQ对您发起咨询</p>
        </el-form-item>
        <el-form-item label="擅长领域：">
          <el-checkbox-group v-model="formMedia.specialty">
            <el-checkbox label="户外">户外</el-checkbox>
            <el-checkbox label="健身">健身</el-checkbox>
            <el-checkbox label="游泳">游泳</el-checkbox>
            <el-checkbox label="运动">运动</el-checkbox>
          </el-checkbox-group>
          <p class="help">*最多两项，请慎重选择，官方将从擅长的领域进行考核并重点扶持</p>
        </el-form-item>
        <el-form-item label=" ">
          <zt-button type="primary" size="medium">提交信息</zt-button>
        </el-form-item>
      </el-form>
    </zt-dialog>

    <!-- dialog-联系信息 -->
    <zt-dialog
      title="修改联系信息"
      :visible.sync="dialogVisible.contact"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <el-form
        class="dialog-form mt8"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
        @submit.native.prevent
        :model="formContact"
        ref="formContact"
      >
        <el-form-item label="联系手机：">
          <el-input
            type="number"
            step="1"
            class="input-middle"
            v-model.trim="formContact.phone"
            placeholder="请输入联系手机"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input class="input-short" v-model.trim="formContact.yzm" placeholder="请输入验证码"></el-input>
          <zt-button type="primary" class="input-button ml8" plain size="medium">获取验证码</zt-button>
        </el-form-item>
        <el-form-item label="联系QQ：">
          <el-input v-model.trim="formContact.qq" placeholder="请输入联系QQ"></el-input>
          <p class="help">*主推官方将会通过该QQ与您取得联系</p>
        </el-form-item>
        <el-form-item label="联系邮箱：">
          <el-input v-model.trim="formContact.email" placeholder="请输入联系邮箱"></el-input>
          <p class="help">*请输入常用的邮箱,以便接收消息</p>
        </el-form-item>
        <el-form-item label="营运者所在地：">
          <el-cascader :options="srcFormContact.location" v-model="formContact.location"></el-cascader>
          <p class="help">*选择营运者所在地</p>
        </el-form-item>
        <el-form-item label=" ">
          <zt-button type="primary" size="medium">提交信息</zt-button>
        </el-form-item>
      </el-form>
    </zt-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import default_avatar from '@imgs/default_avatar.png';
import ZtDialog from '@cps/ZtDialog';
import { limitObject } from '@/utils';

export default {
  components: {
    ZtDialog,
  },
  name: 'myCenterDatum',
  props: {
    isChange: Boolean,
  },
  computed: {
    ...mapGetters(['name', 'avatar', 'roles', 'user_info']),
    role: ({ roles }) => roles[0],
    role_cn({ role }) {
      return role == 'admin' ? '管理员' : role == 'editor' ? '编辑' : '淘客';
    },
  },
  data: () => ({
    default_avatar,

    // 媒体信息
    media: {
      face: '',
      taobao_nickname: '',
      desc: '',
      specialty: [],
      qq: '',
      telephone: '',
      roles: [],
    },
    // 媒体信息 - 表单
    formMedia: {
      nick: 'admin名字',
      face: '',
      remark: '',
      qq: '',
      specialty: ['户外', '户外'],
    },
    // 联系信息
    contact: {
      name: '**杰',
      qq: '*********173',
      identity: '32**************28',
      email: '32*****@qq.com',
      phone: '123****5328',
      location: '江苏省/盐城市/盐都区',
    },
    // 联系信息 - 表单
    formContact: {
      phone: '',
      yzm: '',
      qq: '',
      email: '',
      location: [],
    },
    srcFormContact: {
      location: [
        {
          label: '广东省',
          value: '广东省',
          children: [
            {
              label: '广州市',
              value: '广州市',
              children: [
                {
                  label: '天河区',
                  value: '天河区',
                },
              ],
            },
          ],
        },
      ],
    },
    // dialog 可见度
    dialogVisible: {
      media: false,
      contact: false,
    },
    loading: {
      dialogMedia: false,
      dialogContact: false,
    },
  }),
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      var info = limitObject(
        this.$store.getters.user_info,
        ['telephone', 'taobao_nickname', 'face'],
        true
      );
      Object.assign(this.media, info);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/form.scss";
.datum {
  font-size: 14px;
}
.ml138 {
  position: relative;
  margin-left: 138px;
}
.mt32 {
  margin-top: 32px;
}
.border1 {
  border-top: 1px solid $theme-border3;
}
.face {
  position: absolute;
  top: 0;
  left: -138px;
  margin-left: 6px;
  margin-top: 14px;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 44px;
  .title {
    font-size: 18px;
    font-weight: 600;
  }
}
.desc {
  color: $theme-textsecond;
  line-height: 20px;
}

.info-table {
  margin: 8px 0;
  .info-table-row {
    display: flex;
    align-items: center;
    line-height: 20px;
  }
  .info-table-row ~ .info-table-row {
    margin-top: 16px;
  }
  .label {
    width: 74px;
    margin-right: 10px;
    color: $theme-textsecond;
    line-height: 20px;
  }
  .content {
    color: $theme-textnormal;
  }
}

.role {
  margin-left: 12px;
  padding: 0 4px;
  text-align: center;
  line-height: 14px;
  height: 13px;
  color: #fff;

  border-radius: 13px 7px 7px 0;
  font-size: 12px;
  word-break: keep-all;
  i {
    display: inline-block;
    transform: scale(0.75, 0.75);
    font-style: normal;
  }
  &.taoke {
    background: $theme-gold;
  }
  &.admin {
    background: $theme;
  }
  &.editor {
    background: $theme-purple;
  }
}

.kind-tag {
  display: inline-block;
  padding: 2px 12px;
  font-size: 12px;
  color: #1b7ce1;
  background-color: #d7ebff;
  border-radius: 13px;
  line-height: 18px;
  ~ .kind-tag {
    margin-left: 8px;
  }
}

.dialog-form {
  padding: 0 12px;
  .input-middle {
    margin-right: 16px;
  }
}
</style>